export default __webpack_public_path__ + "static/Image003_small-15c8ef38817b54eb84744dd361de0962.png";